import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const agentWorkTime: TComputedPropMapper<string | undefined> = ({ offer: { workTimeInfo } }) => {
  if (workTimeInfo) {
    let { callFrom = '', callTo = '' } = workTimeInfo;

    if (callFrom && callTo) {
      callFrom = callFrom.slice(0, 5);
      callTo = callTo.slice(0, 5);
    }

    return callFrom && callTo ? `Работает с ${callFrom} до ${callTo}` : undefined;
  }

  return undefined;
};
